import { defineStore } from "pinia";

export const useBillStore = defineStore('billStore', {
    state:()=>({
        data:null,
    }),
    getters:{
        getBills:(state) => state.data,
    }
})